var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmsClockToweAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#0065FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_561_1492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 17.0976V12.1109C9.33337 10.5776 10.58 9.33089 12.1134 9.33089H12.6667V15.3776L9.33337 17.0976ZM16.7867 9.33089H13.78V15.4909L17.0667 18.7776H22.6667V15.2109C22.6267 15.2509 22.5934 15.2909 22.56 15.3309L21.5267 16.3376C21.0134 16.8376 20.3334 17.1109 19.6134 17.1109C18.8934 17.1109 18.2134 16.8376 17.7 16.3309L16.68 15.3376C15.88 14.5376 15.4467 13.4909 15.4467 12.3776C15.4467 11.2642 15.88 10.2176 16.6667 9.43089C16.7067 9.39089 16.7467 9.35755 16.7867 9.32422V9.33089ZM16.1 19.3842L13.12 16.4042L9.33337 18.3442V19.8842C9.33337 21.4176 10.58 22.6642 12.1134 22.6642H13.64L16.1 19.3842ZM15.0267 22.6642H19.8867C21.42 22.6642 22.6667 21.4176 22.6667 19.8842H17.1134L15.0334 22.6642H15.0267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7667 10.2254C21.1933 9.65203 20.4267 9.33203 19.6067 9.33203C18.7867 9.33203 18.0267 9.65203 17.4467 10.2254C16.8733 10.8054 16.5533 11.572 16.5533 12.3854C16.5533 13.1987 16.8733 13.972 17.4533 14.552L18.4733 15.552C18.7867 15.8587 19.2 16.012 19.6067 16.012C20.0133 16.012 20.4333 15.8587 20.7467 15.552L21.7667 14.5454C22.3467 13.972 22.6667 13.2054 22.6667 12.3854C22.6667 11.5654 22.3467 10.8054 21.7667 10.2254ZM19.6067 13.2187C19.1467 13.2187 18.7733 12.8454 18.7733 12.3854C18.7733 11.9254 19.1467 11.552 19.6067 11.552C20.0667 11.552 20.44 11.9254 20.44 12.3854C20.44 12.8454 20.0667 13.2187 19.6067 13.2187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_561_1492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(9.33337 9.33203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmsClockToweAct);
export default __webpack_public_path__ + "static/media/tmsClockToweAct.fe2d6c9800cccc3d3df1cc7361dec18c.svg";
export { ForwardRef as ReactComponent };